import { BannerRoot, BannerContent, BannerIcon, BannerMessage, BannerActions, BannerDismiss, BannerActionLabel } from './banner-primitives';

export const Banner = {
  get Root() {
    return BannerRoot;
  },
  get Content() {
    return BannerContent;
  },
  get Icon() {
    return BannerIcon;
  },
  get Message() {
    return BannerMessage;
  },
  get Actions() {
    return BannerActions;
  },
  get ActionLabel() {
    return BannerActionLabel;
  },
  get Dismiss() {
    return BannerDismiss;
  },
};
